import Vue from 'vue';
import _ from 'lodash';
import axios from 'axios';
import echarts from 'echarts';
window.echarts = echarts;

import App from './App';
import router from './router';
import store from './store';

import 'font-awesome/css/font-awesome.css';
import './theme/default.styl';

import NProgress from '@/plugins/NProgress';
import firebase from '@/plugins/Firebase';
import FacebookPixel from '@/plugins/FacebookPixel';

import '@/plugins/Vuetify';
import '@/plugins/VuetifyConfirm';
import '@/plugins/Dayjs';
import '@/plugins/VeeValidate';
import '@/plugins/VCurrencyField';
import '@/plugins/Vue2Filters';
import '@/plugins/VueCroppie';

import '@/util/filters';
import qzTray from "@/util/qz-tray";
import GeradorCupom from "@/util/GeradorCupom";
import config from "@/util/config";
import { isNovidadePromo } from '@/util/promocao';

// const messaging = firebase.messaging.isSupported() ? firebase.messaging() : null;

Vue.use(FacebookPixel, {
  appId: '1656028495112608',
  version: 'v23.0',
});

const normalizeText = text =>
  String(text == null ? '' : text).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

// Cache do texto normalizado de cada loja, usado pela busca do seletor.
const indiceBuscaLojas = new WeakMap();

const getIndiceBusca = item => {
  let indice = indiceBuscaLojas.get(item);

  if (!indice) {
    indice = {
      id: normalizeText(item.id),
      nome: normalizeText(item.nome),
      localidade: normalizeText(item.localidade),
    };
    indiceBuscaLojas.set(item, indice);
  }

  return indice;
};

const axiosConfig = {
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 30000,
};
Vue.prototype.$axios = axios.create(axiosConfig);
Vue.prototype.$firebase = firebase;
Vue.prototype.$axios.interceptors.request.use(config => {
  // Do something before request is sent

  config.headers.authorization = process.env.VUE_APP_AUTH_KEY;
  config.headers.token = store.getters.token ? store.getters.token : store.getters.user ? store.getters.user.token : null;
  store.dispatch('setLoading', true);
  return config;
}, error => {
  // Do something with request error
  store.dispatch('setLoading', false);
  return Promise.reject(error);
});
Vue.prototype.$axios.interceptors.response.use(response => {
  store.dispatch('setLoading', false);
  return response;
}, error => {
  store.dispatch('setLoading', false);
  if (error?.response?.status === 401) {
    window.getApp.$emit('APP_AUTH_FAILED');
  } else if (error?.response?.status === 403) {
    window.getApp.$emit('APP_ACCESS_DENIED');
  } else if (error?.response?.status === 500) {
    window.getApp.$emit('APP_BAD_REQUEST');
  }
  return Promise.reject(error);
});

Vue.config.productionTip = false;

new Vue({
  data: {
    optionsRingtones : config.optionsRingtones,
    optionsDrivers: config.optionsDrivers,
    optionsPrinters: config.optionsPrinters,
    optionsLayout: config.optionsLayout,
    optionsConfirmation: config.optionsConfirmation,
    recessos:[],
    allPedidos: [],
    pedido: null,
    ring: null,
    swReg: null,
    subscribed: false,
    pedido_mobile: null,
    notificacoes: [],
    boletos: [],
    promocoes: [],
    printers: [],
    alertBoletos: true,
    agendamentosCount: 0,
    printer_connected: false,
    socket_connected: false,
    dialog: {
      aux: false,
      printer: false,
      termoAdesao: false
    },
    termoAdesao: null,
    currentRoute: null,
    intervalQZ: null,
    firebaseRemoteConfig: {
      NOVA_INTERFACE_FINANCEIRO: false,
      QUANTIDADE_AVALIACOES: {},
      WPP_SUPORTE: '5532988929726',
    },
    onboardingData: null,
  },
  computed: {
    isProduction () {
      return process.env.VUE_APP_NODE_ENV === 'production'
    },
    enums () {
      return store.getters.enums;
    },
    user () {
      return store.getters.user;
    },
    token () {
      return store.getters.token;
    },
    loading () {
      return store.getters.loading;
    },
    estabelecimentoSelecionado () {
      return store.getters.estabelecimentoSelecionado;
    },
    showContrato () {
      const venda = this.estabelecimentoSelecionado && this.estabelecimentoSelecionado.vendas ? _.find(this.estabelecimentoSelecionado.vendas, o => {
        return o.status == this.enums.STATUS.VENDA_ATIVA || o.status == this.enums.STATUS.VENDA_SUSPENSA || o.status == this.enums.STATUS.VENDA_PENDENTE;
      }) : null;
      return !!venda && !!venda.contrato_url && venda.contrato_status == this.enums.STATUS.CONTRATO_PENDENTE;
    },
    badgeContratoPendente () {
      const venda = this.estabelecimentoSelecionado && this.estabelecimentoSelecionado.vendas ? _.find(this.estabelecimentoSelecionado.vendas, o => {
        return o.status == this.enums.STATUS.VENDA_ATIVA || o.status == this.enums.STATUS.VENDA_SUSPENSA || o.status == this.enums.STATUS.VENDA_PENDENTE;
      }) : null;
      return !!venda && !!venda.contrato_url && venda.contrato_status == this.enums.STATUS.CONTRATO_PENDENTE ? 1 : 0;
    },
    cardapioDigital () {
      return store.getters.estabelecimentoSelecionado && store.getters.estabelecimentoSelecionado.cardapio_digital == 1;
    },
    estabelecimentos () {
      return store.getters.estabelecimentos;
    },
    driver () {
      return store.getters.driver;
    },
    ringtone () {
      return store.getters.ringtone;
    },
    printer () {
      return store.getters.printer;
    },
    print () {
      return store.getters.print;
    },
    printLayout (){
      return store.getters.printLayout;
    },
    confirmation (){
      return store.getters.confirmation;
    },
    pedidos () {
      const vm = this;
      const allPedidos = _.uniqBy(vm.allPedidos, 'id');
      const pedidos = vm.estabelecimentoSelecionado && vm.estabelecimentoSelecionado.id ? _.filter(allPedidos, { estabelecimento_id: vm.estabelecimentoSelecionado.id }) : allPedidos;
      const pedidosRecebidos = _.orderBy(_.filter(pedidos, p => p.status !== 0), ['data'], ['desc']);
      const pedidosAguardando = _.orderBy(_.filter(pedidos, p => p.status === 0), ['data'], ['asc']);
      document.title = 'Bigou Delivery' + (pedidosAguardando.length ? ` (${pedidosAguardando.length})` : '');
      return pedidosAguardando.concat(pedidosRecebidos);
    },
    lastAccessNotification () {
      return store.getters.lastAccessNotification;
    },
    pedidosAguardando () {
      const vm = this;
      const allPedidos = _.uniqBy(vm.allPedidos, 'id');
      const pedidos = vm.estabelecimentoSelecionado && vm.estabelecimentoSelecionado.id ? _.filter(allPedidos, { estabelecimento_id: vm.estabelecimentoSelecionado.id }) : allPedidos;
      return _.countBy(pedidos, { status: 0 }).true || 0;
    },
    pedidoSelecionado () {
      return this.pedido || this.pedido_mobile;
    },
    boletosDisponiveis () {
      if(!this.enums || !this.enums.STATUS) return 0;
      const BOLETO_VENCENDO = this.enums.STATUS.BOLETO_VENCENDO;
      const BOLETO_VENCIDO  = this.enums.STATUS.BOLETO_VENCIDO;
      return (this.estabelecimentoSelecionado && this.estabelecimentoSelecionado.id) || this.estabelecimentos.length == 1 ?
        (_.countBy(this.boletos, b => b.status == BOLETO_VENCENDO || b.status == BOLETO_VENCIDO).true || 0) : 0;
    },
    boletosVencendo () {
      const vm = this;
      const BOLETO_VENCENDO = store.getters.enums.STATUS.BOLETO_VENCENDO;
      return _.countBy(vm.boletos, b => b.status == BOLETO_VENCENDO).true || 0;
    },
    boletosVencidos () {
      const vm = this;
      const BOLETO_VENCIDO = store.getters.enums.STATUS.BOLETO_VENCIDO;
      return _.countBy(vm.boletos, b => b.status == BOLETO_VENCIDO).true || 0;
    },
    promocoesAguardando () {
      // Alinhado ao badge "Novidade" do Marketing (isNovidadePromo):
      // status === 1 && ativo === 1.
      return _.countBy(this.promocoes, isNovidadePromo).true || 0;
    },
    notificacoesPendentes () {
      const vm = this;
      let lastAccess = store.getters.lastAccessNotification;

      if (!lastAccess || typeof lastAccess != 'string') {
        lastAccess = vm.$dayjs().format();
        vm.setLastAccessNotification(lastAccess);
        return 0;
      }

      return _.countBy(vm.notificacoes, n => vm.$dayjs(lastAccess).isBefore(vm.$dayjs(n.data_envio, 'YYYY-MM-DD HH:mm:ss'))).true || 0;
    },
    printerConnected () {
      return this.printer_connected;
    },
    socketConnected () {
      return this.socket_connected;
    },
    badgeTermoAdesao () {
      return this.termoAdesao && this.user && this.termoAdesao.versao > this.user.termo_adesao ? 1 : 0;
    },
    cardapio () {
      return store.getters.cardapio;
    },
    colors () {
      return this.$vuetify.theme;
    },
    userIsAdmin () {
      const email = this.user ? this.user.email : '';
      return (
        email.indexOf('@labcinco.com') > -1 ||
        email.indexOf('@lab5studio.com') > -1 ||
        email.indexOf('@bigou.com.br') > -1 ||
        email.indexOf('@bigou.app') > -1
      )
    },
    FIREBASE_REMOTE_CONFIG () {
      return this.firebaseRemoteConfig;
    },
    isOnboardingPendente () {
      if (!this.enums || !this.enums.STATUS) return false;
      if (!this.estabelecimentoSelecionado || !this.estabelecimentoSelecionado.vendas) return false;
      const vendaPendente = !!this.estabelecimentoSelecionado.vendas.find(v =>
        v.status == this.enums.STATUS.VENDA_PENDENTE
      );
      if (!vendaPendente) return false;
      // Registro deve existir no banco (criado pelo admin CMS)
      if (!this.onboardingData || !this.onboardingData.id) return false;
      // Parceiro já concluiu a parte dele — oculta todo o UI de onboarding
      if (this.onboardingData.feedback_experiencia) return false;
      return true;
    },
    onboardingEtapasPendentes () {
      return this.onboardingData ? this.onboardingData.etapasPendentes : null;
    },
    onboardingTotal () {
      if (!this.onboardingData) return 0;
      const campos = ['etapa_cardapio', 'etapa_horario', 'etapa_pagamento', 'etapa_entrega', 'etapa_configuracoes', 'etapa_impressora'];
      return campos.filter(e => !(e === 'etapa_impressora' && this.onboardingData[e] === null)).length;
    },
    onboardingConcluidas () {
      if (!this.onboardingData || !this.onboardingTotal) return 0;
      return this.onboardingTotal - (this.onboardingData.etapasPendentes || 0);
    },
    onboardingPct () {
      if (!this.onboardingTotal) return 0;
      return Math.round((this.onboardingConcluidas / this.onboardingTotal) * 100);
    },
    onboardingEtapaAtualLabel () {
      if (!this.onboardingData) return '';
      const labels = {
        etapa_cardapio:      'Cardápio',
        etapa_horario:       'Horário de funcionamento',
        etapa_pagamento:     'Formas de pagamento',
        etapa_entrega:       'Taxas de entrega',
        etapa_configuracoes: 'Configurações',
        etapa_impressora:    'Impressora',
      };
      return labels[this.onboardingData.primeiraEtapaPendente] || '';
    },
    isOnboardingAguardando () {
      if (!this.enums || !this.enums.STATUS) return false;
      if (!this.estabelecimentoSelecionado || !this.estabelecimentoSelecionado.vendas) return false;
      const vendaPendente = !!this.estabelecimentoSelecionado.vendas.find(v =>
        v.status == this.enums.STATUS.VENDA_PENDENTE
      );
      if (!vendaPendente) return false;
      if (!this.onboardingData || !this.onboardingData.id) return false;
      return !!(this.onboardingData.feedback_experiencia);
    },
    layoutImpressaoNormalSelecionado () {
      return !this.printLayout || this.printLayout.id == 1;
    },
    layoutImpressaoLimpoSelecionado () {
      return this.printLayout && this.printLayout.id == 2;
    },
    layoutImpressaoSimplificadoSelecionado () {
      return this.printLayout && this.printLayout.id == 3;
    },
  },
  created() {
    this.getFirebaseRemoteConfigValues();
    this.unregisterServiceWorker()
    router.beforeResolve(async (to, from, next) => {
      if (this.$root.isLogged()) {
        await Promise.all([
          this.getEnums(),
          this.getTermoAdesao(),
          // this.getNotificacoes(),
        ])

        if (this.$root.termoAdesao && ((this.$root.termoAdesao.versao > this.$root.user.termo_adesao && this.$root.termoAdesao.obrigatorio == 2) || (this.$root.user.termo_adesao == 0 && this.$root.termoAdesao.obrigatorio))) {
          this.$root.openDialogTermoAdesao();
        }
      }
      next();
    });
  },
  watch: {
    loading (val) {
      if (val) NProgress.start();
      else NProgress.done();
    },
    lastAccessNotification (val) {
      if (!val) this.setLastAccessNotification(this.$dayjs().format());
    },
    pedidosAguardando (val) {
      if (!this.ring) {
        if (this.ringtone) this.selectRingtone(this.ringtone);
        else this.selectRingtone(this.optionsRingtones[0]);
      }
      if (val) this.ringBell();
      else if (!val && !_.isNil(this.ring) && !this.ring.paused) this.stopRing();
    },
    '$route.path': {
      handler(newValue, oldValue) {
        if(newValue != oldValue) {
          if(newValue == '/delivery/pedidos' || oldValue == '/delivery/pedidos' || oldValue == '/'){
            this.currentRoute = newValue;
          }
        };
      },
      deep: true
    },
    'estabelecimentoSelecionado.id': {
      handler(newId) {
        if (newId) this.fetchOnboarding(true);
      },
    },
  },
  methods: {
    podeAcessarPerfil (perfis) {
      if (!perfis || !perfis.length) return true;
      const perfilAcesso = (this.user && this.user.perfil_acesso) || 'administrador';
      return perfis.includes(perfilAcesso);
    },
    async getFirebaseRemoteConfigValues () {
      const values = [
        {
          key: 'NOVA_INTERFACE_FINANCEIRO',
          as: 'asBoolean',
        },
        {
          key: 'QUANTIDADE_AVALIACOES',
          as: 'asJSON',
        },
        {
          key: 'WPP_SUPORTE',
          as: 'asString',
        },
      ];
      await Promise.all(
        values.map(async item => {
          const value = await firebase.getRemoteConfigValue(item.key);
          if (!value) return; // fetch falhou → mantém o default
          this.firebaseRemoteConfig[item.key] = value[item.as]();
        })
      );
    },
    showOrigemPedido(){
      if(_.find(this.estabelecimentos, { 'cardapio_digital': 1 })){
        return true;
      }else{
        return false;
      }
    },
    updateEstabelecimento (estabelecimento) {
      if (this.estabelecimentoSelecionado && this.estabelecimentoSelecionado.id == estabelecimento.id) {
        store.commit('setEstabelecimentoSelecionado', estabelecimento);
      }
      const index = _.findIndex(this.estabelecimentos, o => o.id == estabelecimento.id);
      this.estabelecimentos[index] = estabelecimento;
      store.dispatch('setEstabelecimentos', this.estabelecimentos);
    },
    async unregisterServiceWorker() {
      // Verifica se o navegador suporta service workers
      if ('serviceWorker' in navigator) {
          // Obtém todos os service workers registrados
          const registrations = await navigator.serviceWorker.getRegistrations();

          // Itera sobre todos os registros e os remove
          for (const registration of registrations) {
            if(registration.active.scriptURL.includes('/sw.js')){
              await registration.unregister();
              console.log('Service worker unregistered:', registration);
            }
          }
      } else {
          console.log('Service workers are not supported in this browser.');
      }
    },
    showIdentify (pedido) {
      return pedido.cardapio_digital == 1 || (store.getters.user.permissao === 3 && pedido && (pedido.status === 1 || pedido.status === 2)) || store.getters.user.permissao !== 3;
	  },
    async getPedido (id) {
      const vm = this;
      try {
        if (!id) throw 'Pedido não encontrado!';
        const response = await vm.$axios.get('/pedido', { params: { id } });
        if (!response.data.length) if (!id) throw 'Pedido não encontrado!';
        return response.data[0];
      } catch (error) {
        throw new Error(error);
      }
    },
    async getNotificacoes () {
      const vm = this;
      try {
        const response = await vm.$axios.get('/notificacao');
        vm.notificacoes = response.data;
        window.getApp.$emit('NOTIFICACAO')
        return response.data;
      } catch (error) {
        throw new Error(error);
      }
    },
    async getPromocoes (estabelecimento_id) {
      const vm = this;
      if (!estabelecimento_id) {
        vm.promocoes = [];
        return;
      }
      const estab = _.find(vm.estabelecimentos, { id: estabelecimento_id });
      if (estab && estab.cardapio_digital) {
        vm.promocoes = [];
        return;
      }
      try {
        const { data } = await vm.$axios.get('/campanha/promocao', {
          params: { estabelecimento_id }
        });
        vm.promocoes = data || [];
        return vm.promocoes;
      } catch (error) {
        vm.promocoes = [];
      }
    },
    async getBoletos (estabelecimento_id) {
      const vm = this;
      if (!estabelecimento_id) return;
      try {
        const { data: boletos } = await vm.$axios.get('/boleto',{
          params : {
            estabelecimento_id : estabelecimento_id
          }
        });
        vm.boletos = boletos;
        return vm.boletos;
      } catch (error) {
        throw new Error(error);
      }
    },
    async getRecessos(estabelecimento){
      if (!estabelecimento || !estabelecimento.id) return;
      try{
        const response = await vm.$axios.get('/recessos-vigentes', {
          params: {
            estabelecimento_id: estabelecimento.id
          }
        });
        return response.data;
      }catch(e){
        throw new Error(e);
      }
    },
    getStatusFatura (fatura){
      if (fatura.id && fatura.antecipada) {
        return {
          backgroundcolor: "#0060C80A",
          color: "#0060C8",
          label: "Antecipada",
        }
      }

      if (fatura.id) {
        return {
          backgroundcolor: "#1D9A5A14",
          color: "#0F7641",
          label: "Gerada",
        }
      }

      if (!fatura.id) {
        return {
          backgroundcolor: "#FF950014",
          color: "#FF9500",
          label: "Vigente",
        }
      }
    },
    getStatusBoleto (vencimento) {
      const vm = this;
      let dataAtual = vm.$dayjs().startOf('day');
      let diasVencimento = vm.$dayjs(vencimento).startOf('day').diff(dataAtual, 'days');
      return vm.$dayjs(vencimento, 'YYYY-MM-DD').startOf('day').isBefore(dataAtual) ? 2 : diasVencimento >= 0 && diasVencimento <= 2 ? 1 : 0;
    },
    createReferenciaBoletos (boletos) {
      const vm = this;
      var minReferencia = _.minBy(boletos, parcela => vm.$dayjs(parcela.data_referencia, 'YYYY-MM-DD').unix());
      var maxReferencia = _.maxBy(boletos, parcela => vm.$dayjs(parcela.data_referencia, 'YYYY-MM-DD').unix());
      return minReferencia == maxReferencia ? vm.$dayjs(minReferencia.data_referencia).format("MMM YYYY").toUpperCase() : (vm.$dayjs(minReferencia.data_referencia).format("MMM YYYY") + " - " + vm.$dayjs(maxReferencia.data_referencia).format("MMM YYYY")).toUpperCase();
    },
    async saveToken (token, logout) {
      const vm = this;
      await vm.$axios.post('/token', {
        token,
        tipo: 'new-web-fcm',
        usuario_id: logout ? "NULL" : vm.isLogged() ? vm.user.id : "NULL",
        localidade_id : 0,
        estabelecimento: 1,
      });
    },
    async getToken (logout) {
      const vm = this;
      try {
        const currentToken = await firebase.getToken();
        // console.log('currentToken', currentToken)
        if (currentToken) vm.saveToken(currentToken, logout)
        else console.log('No Instance ID token available. Request permission to generate one.');
      } catch (error) {
        console.log('An error occurred while retrieving token. ', error);
      }
    },
    isSubscribed () {
      return this.swReg !== null && this.subscribed ? true : false;
    },
    isLogged () {
      return this.user && this.user.id ? true : false;
    },
    variacoesPadrao (variacoes){
      return _.orderBy(variacoes, variacao => variacao.variacao.indice);
    },
    variacoes (variacoes) {
      var group = _.groupBy(variacoes, 'item_catalogo_id');
      var listVariacoes = []
      for(var i in group){
        var variacao = group[i][0]
        var quantidade = group[i].length;
        listVariacoes.push({
          quantidade : quantidade,
          nome : variacao.item.nome,
          variacao : variacao.variacao.nome,
          preco : quantidade*variacao.preco,
          indice : variacao.item.indice_categoria || 0,
          mod_preco : variacao.mod_preco
        });
      }
      return listVariacoes;
    },
    ringBell (options) {
      if (!this.ring) return;
      const once = !!(options && options.once);
      if (!once && !this.pedidosAguardando) return this.stopRing();
      if (once) {
        // Alerta já tocando por um pedido pendente: não interrompe nem encurta.
        if (!this.ring.paused) return;
        this.ring.loop = false;
      } else {
        this.ring.loop = this.ringtone.id == 1 ? false : true;
        if (!this.ring.paused && this.ringtone.id != 1) return;
      }
      this.ring.play()
      .then(function() {})
      .catch(function(error) {});
    },
    stopRing () {
      if (!this.ring) return;
      this.ring.pause();
      this.ring.currentTime = 0;
    },
    customFilter(item, queryText, itemText) {
      const hasValue = val => val != null ? val : '';
      const text = hasValue(item.nome);
      const query = hasValue(queryText);
      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    },
    formatRating (value) {
      return value ? parseFloat(value.toString()).toFixed(1) : '0.0';
    },
    getStars (value) {
      value = parseFloat(value);
      if (value === 0) return ["star_border", "star_border", "star_border", "star_border", "star_border"];
      else if (value > 0 && value < 1) return ["star_half", "star_border", "star_border", "star_border", "star_border"];
      else if (value === 1) return ["star", "star_border", "star_border", "star_border", "star_border"];
      else if (value > 1 && value < 2) return ["star", "star_half", "star_border", "star_border", "star_border"];
      else if (value === 2) return ["star", "star", "star_border", "star_border", "star_border"];
      else if (value > 2 && value < 3) return ["star", "star", "star_half", "star_border", "star_border"];
      else if (value === 3) return ["star", "star", "star", "star_border", "star_border"];
      else if (value > 3 && value < 4) return ["star", "star", "star", "star_half", "star_border"];
      else if (value === 4) return ["star", "star", "star", "star", "star_border"];
      else if (value > 4 && value < 5) return ["star", "star", "star", "star", "star_half"];
      else if (value === 5) return ["star", "star", "star", "star", "star"];
      else return null;
    },
    formatURL(str){
      return str.toLowerCase().trim()
      .replace(/[áàãâä]/g, "a")
      .replace(/[éèẽêë]/g, "e")
      .replace(/[íìĩîï]/g, "i")
      .replace(/[óòõôö]/g, "o")
      .replace(/[úùũûü]/g, "u")
      .replace(/ç/g, "c")
      .replace(/(\ |_)+/, " ")
      .replace(/(^-+|-+$)/, "")
      .replace(/[^a-z0-9]+/g, '-');
    },
    buildItemURL(url, item){
      if (!item) return url;

      const cleanURL = url.replace(/[?&]+$/, '');
      const separator = cleanURL.includes('?') ? '&' : '?';
      return `${cleanURL}${separator}item=${item}`;
    },
    getURLCardapioDigital(estabelecimento, item){
      const slug = estabelecimento.nome ? this.formatURL(estabelecimento.nome).replace(/-+$/, '') : '';
      const path = slug ? `${slug}-${estabelecimento.uid}` : estabelecimento.uid;
      const url = `${process.env.VUE_APP_SITE_CARDAPIO_URL}/${path}`;
      return this.buildItemURL(url, item);
    },
    getURLBigou(estabelecimento, item){
      const url = `${process.env.VUE_APP_SITE_DELIVERY_URL}/${this.formatURL(estabelecimento.localidade + '-' + estabelecimento.estado)}/estabelecimento/${estabelecimento.id}/${this.formatURL(estabelecimento.nome)}`
      return this.buildItemURL(url, item);
    },
    getURL(estabelecimento, item){
      if(estabelecimento.cardapio_digital){
        return this.getURLCardapioDigital(estabelecimento, item);
      }else{
        return this.getURLBigou(estabelecimento, item);
      }
    },
    removeAccents(s) {
      let r = s ? s.toLowerCase() : "";
      // r = r.replace(new RegExp('\\s', 'g'), '');
      r = r.replace(new RegExp('[àáâãäå]', 'g'), 'a');
      r = r.replace(new RegExp('æ', 'g'), 'ae');
      r = r.replace(new RegExp('ç', 'g'), 'c');
      r = r.replace(new RegExp('[èéêë]', 'g'), 'e');
      r = r.replace(new RegExp('[ìíîï]', 'g'), 'i');
      r = r.replace(new RegExp('ñ', 'g'), 'n');
      r = r.replace(new RegExp('[òóôõö]', 'g'), 'o');
      r = r.replace(new RegExp('œ', 'g'), 'oe');
      r = r.replace(new RegExp('[ùúûü]', 'g'), 'u');
      r = r.replace(new RegExp('[ýÿ]', 'g'), 'y');
      // r = r.replace(new RegExp('\\W', 'g'), '');
      r = r.replace('\'', '');
      r = r.replace('´', "'");
      r = r.replace('`', "'");
      r = r.replace('’', "'");

      return r;
    },
    b64toBlob (image) {
      let block = image.split(';');
      let contentType = block[0].split(':')[1];
      let b64Data = block[1].split(',')[1];
      let sliceSize = 512;
      let byteCharacters = atob(b64Data);
      let byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);
        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      let blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    selectPrintLayout (printLayout){
      store.dispatch('setPrintLayout', printLayout);
    },
    selectConfirmation (confirmation){
      store.dispatch('setConfirmation', confirmation);
    },
    selectRingtone (ringtone) {
      store.dispatch('setRingtone', ringtone);
      if (this.ring) this.ring.pause();
      const ringtoneAplicavel = this.optionsRingtones.find(o=>{
        return o.id == ringtone.id;
      })
      this.ring = new Audio(ringtoneAplicavel.file);
      if (this.pedidosAguardando) this.ringBell();
    },
    async validateQZPrinters () {
      const vm = this;
      try {
        if (!vm.driver || vm.driver.id !== 2) return;

        const currentPrinters = Array.isArray(vm.printer) ? _.cloneDeep(vm.printer) : vm.printer ? [vm.printer] : [];
        if (!currentPrinters.length) return;

        let availablePrinters = [];
        try {
          if (!qzTray.isActive()) await qzTray.connect();
          availablePrinters = await qzTray.getPrinters();
        } catch (e) {
          console.warn('QZ Tray não disponível para validação de impressoras:', e);
          return;
        }

        const validPrinters = currentPrinters.filter(p => availablePrinters.includes(p.nome));

        const nextPrinters = validPrinters.length ? validPrinters : null;
        const currentState = currentPrinters;
        const changed = JSON.stringify(currentState) !== JSON.stringify(nextPrinters);
        if (changed) store.dispatch('setPrinter', nextPrinters);
      } catch (error) {
        console.warn('Erro ao validar impressoras QZ Tray:', error);
      }
    },
    selectDriver (driver) {
      store.dispatch('setDriver', driver);
    },
    selectPrinter (printer) {
      store.dispatch('setPrinter', printer);
      this.dialog.printer = false;
    },
    selectPrint (print) {
      store.dispatch('setPrint', print);
    },
    setLastAccessNotification (value) {
      const vm = this;
      if (value && typeof value == 'object' && typeof value.format == 'function') {
        store.dispatch('setLastAccessNotification', value.format());
      } else if (typeof value == 'string' && vm.$dayjs(value).isValid()) {
        store.dispatch('setLastAccessNotification', value);
      } else {
        store.dispatch('setLastAccessNotification', vm.$dayjs().format());
      }
    },
    printElement (pedido, tab) {
      const vm = this;
      if (vm.layoutImpressaoNormalSelecionado) {
        GeradorCupom.printPadrao(pedido, vm, window, document, tab);
      } else if (vm.layoutImpressaoLimpoSelecionado) {
        GeradorCupom.printNovo(pedido, vm, window, document, tab);
      } else if (vm.layoutImpressaoSimplificadoSelecionado) {
        GeradorCupom.printSimplificado(pedido, vm, window, document, tab);
      }
    },
    async openDialogPrinter () {
      const vm = this;
      try {
        vm.printers = await vm.getPrinters();
        vm.dialog.printer = true;
      } catch (error) {
        throw new Error(error);
      }
    },
    checkPrinterConnection () {
      const vm = this;
      if (vm.intervalQZ) clearInterval(vm.intervalQZ);
      vm.intervalQZ = setInterval(() => {
        vm.printer_connected = qzTray.isConnected();
      }, 5000);
    },
    async connectPrinter () {
      const vm = this;
      try {
        vm.checkPrinterConnection();
        if (vm.printerConnected) {
          return true;
        }
        await qzTray.connect();
      } catch (error) {
        throw new Error('Verifique se o software QZ Tray está aberto e tente novamente!');
      }
    },
    async getPrinters () {
      try {
        const result = await qzTray.getPrinters();
        if (!result.length) throw 'Nenhuma impressora encontrada!';
        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
    async getPrinter (printer) {
      try {
        const result = await qzTray.getPrinter(printer);
        if (!result) throw 'Nenhuma impressora selecionada!';
        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
    async printPedido (pedido) {
      const vm = this;
      try {
        console.log(`🖨️ Imprimindo pedido: ${pedido.id}`);
        if (vm.driver && vm.driver.id == 1) {
          vm.printElement(pedido);
        } else if(vm.driver && vm.driver.id == 2 || vm.driver.id == 4){
          if (!vm.printerConnected)
            await vm.connectPrinter();
          if (!vm.printer)
            return vm.openDialogPrinter();
          await vm.getPrinter(vm.printer);
          await qzTray.print({ pedido, printers: vm.printer, layout: vm.printLayout });
        } else {
          vm.printElement(pedido, true);
        }
      } catch (error) {
        console.error(`❌ Erro ao imprimir pedido: ${pedido.id}`, error);
        throw new Error(error);
      }
    },
    regexURL (str) {
      const regex = /((?:(http|https|Http|Https|rtsp|Rtsp):\/\/(?:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,64}(?:\:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,25})?\@)?)?((?:(?:[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}\.)+(?:(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])|(?:biz|b[abdefghijmnorstvwyz])|(?:cat|com|coop|c[acdfghiklmnoruvxyz])|d[ejkmoz]|(?:edu|e[cegrstu])|f[ijkmor]|(?:gov|g[abdefghilmnpqrstuwy])|h[kmnrtu]|(?:info|int|i[delmnoqrst])|(?:jobs|j[emop])|k[eghimnrwyz]|l[abcikrstuvy]|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])|(?:name|net|n[acefgilopruz])|(?:org|om)|(?:pro|p[aefghklmnrstwy])|qa|r[eouw]|s[abcdeghijklmnortuvyz]|(?:tel|travel|t[cdfghjklmnoprtvwz])|u[agkmsyz]|v[aceginu]|w[fs]|y[etu]|z[amw]))|(?:(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[0-9])))(?:\:\d{1,5})?)(\/(?:(?:[a-zA-Z0-9\;\/\?\:\@\&\=\#\~\-\.\+\!\*\'\(\)\,\_])|(?:\%[a-fA-F0-9]{2}))*)?(?:\b|$)/gi;
      return regex.test(str.replace(/\s/g, ""));
    },
    regexPhone (str) {
      const regex = /(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?/img;
      return regex.test(str.replace(/\s/g, ""));
    },
    openDialogTermoAdesao () {
      if (this.termoAdesao) this.dialog.termoAdesao = true;
    },
    async aceitarTermoAdesao () {
      const vm = this;
      try {
        const usuario = _.cloneDeep(vm.user);
        usuario.termo_adesao = vm.termoAdesao.versao;
        await vm.$axios.put('/usuario', usuario);
        vm.$store.dispatch('setToken', usuario.token);
        setTimeout(function() {
          vm.$store.dispatch('setUser', usuario);
        }, 1000);
        vm.dialog.termoAdesao = false;
        if (vm.$route.name === 'Login') window.getApp.$emit('APP_LOGIN_SUCCESS', { login: true });
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : "Ocorreu um erro ao aceitar os termos. Tente novamente!";
        window.getApp.$emit("APP_ALERT", { color: "red", text: err });
      }
    },
    logout () {
      window.getApp.$emit("APP_LOGOUT");
      this.dialog.termoAdesao = false;
    },
    async getEnums () {
      const vm = this;
      try {
        const { data: enums } = await vm.$axios.get('/enum');
        let localEnums = vm.$root.enums ? _.cloneDeep(vm.$root.enums) : null;
        vm.$store.dispatch('setEnums', localEnums ? Object.assign(localEnums, enums) : enums);
      } catch (error) {
        console.error(error);
      }
    },
    async getTermoAdesao () {
      const vm = this;
      try {
        const { data } = await vm.$axios.get('/termo');
        vm.$root.termoAdesao = data && data.length ? data[0] : null;
        // console.log(vm.$root.termoAdesao);
      } catch (error) {
        console.error(error);
      }
    },
    async fetchOnboarding (abrirModal = false) {
      const vm = this;
      const estabelecimento_id = vm.estabelecimentoSelecionado && vm.estabelecimentoSelecionado.id;
      if (!estabelecimento_id) return;

      // Verifica só a venda pendente (não onboardingData — ainda não foi carregado)
      const enums = vm.enums;
      const PENDENTE = enums && enums.STATUS && enums.STATUS.VENDA_PENDENTE;
      const vendas = vm.estabelecimentoSelecionado.vendas || [];
      const temVendaPendente = vendas.some(v => v.status == PENDENTE);
      if (!temVendaPendente) {
        vm.onboardingData = null;
        return;
      }

      try {
        const { data } = await vm.$axios.get('/onboarding', { params: { estabelecimento_id } });
        vm.onboardingData = data; // null = registro não criado ainda
        if (abrirModal && vm.isOnboardingPendente) window.getApp.$emit('OPEN_ONBOARDING');
      } catch (err) {
        console.error('[Onboarding] fetchOnboarding:', err);
      }
    },
    async atualizarEtapaOnboarding (etapa) {
      const vm = this;
      const estabelecimento_id = vm.estabelecimentoSelecionado && vm.estabelecimentoSelecionado.id;
      if (!estabelecimento_id) return;
      try {
        const { data } = await vm.$axios.put('/onboarding', { estabelecimento_id, [etapa]: 1 });
        vm.onboardingData = data;
        return data;
      } catch (err) {
        console.error('[Onboarding] atualizarEtapa:', err);
        throw err;
      }
    },
    searchLojas(list, searchText) {
      if (!Array.isArray(list)) return [];
      if(!searchText) return list;

      const normalizedSearchText = normalizeText(searchText);

      const porId = [];
      const porNome = [];
      const porLocalidade = [];

      for (const item of list) {
        const indice = getIndiceBusca(item);

        if (indice.id.includes(normalizedSearchText)) {
          porId.push(item);
        } else if (indice.nome.includes(normalizedSearchText)) {
          porNome.push(item);
        } else if (indice.localidade.includes(normalizedSearchText)) {
          porLocalidade.push(item);
        }
      }

      return porId.concat(porNome, porLocalidade);
    },
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app');
